import { render, staticRenderFns } from "./PendingStatusChanges.vue?vue&type=template&id=67cabfa4&"
import script from "./PendingStatusChanges.vue?vue&type=script&lang=js&"
export * from "./PendingStatusChanges.vue?vue&type=script&lang=js&"
import style0 from "./PendingStatusChanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports